import { render } from "./ProviderLayout.vue?vue&type=template&id=428c4758"
import script from "./ProviderLayout.vue?vue&type=script&lang=js"
export * from "./ProviderLayout.vue?vue&type=script&lang=js"

import exportComponent from "/deploy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__